module.exports = __webpack_public_path__ + "static/media/wmDispatch_logo.6be40895.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/wmDispatch_logo.svg
// module id = 2474
// module chunks = 0